/** Shared latest-browser policy: workspace .browserslistrc. Zone.js supports the current Angular bootstrap. */
import 'zone.js';
(window as any).global = window;
import '@angular/localize/init';
